<div class="input-group">
  <input class="form-control" [(ngModel)]="model" (ngModelChange)="onModelChange()"
         [required]="required" step="1" [min]="1" type="number" [readonly]="readonly">
  <span class="input-group-text">days</span>
</div>
